






















































































































































































import { Component, Vue } from "vue-property-decorator";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventCommentPayload from "@/dto/tax/TaxEventCommentPayload";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { YEARS, Period } from "@/constants/DateTimeConstants";
import SelectOption from "@/components/common/SelectOption";
import { TaxEventStatus } from "@/constants/TaxEventStatus";
import { PaymentStatus } from "@/constants/PaymentConstants";
import { Risk } from "@/constants/Risk";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";

@Component({
  components: {
    DictionarySelect,
    PortalInput,
    PortalTextarea,
    PortalSelect,
    SublimeSearch
  }
})
export default class TaxEvent extends Vue {
  
  taxEvent: TaxEventDTO | null = null;
  form: Partial<TaxEventPayload> = {};
  amountLocal: number | string = '';

  assignee: SublimeEmployeeDTO | null = null;

  commentPayload: TaxEventCommentPayload = new TaxEventCommentPayload();

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get sortedComments() {
    if (!this.taxEvent || !this.taxEvent.comments) return [];
    return [...this.taxEvent.comments].sort((a, b) => 
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  mounted(): void {
    this.loadEvent();
  }

  loadEvent(): void {
    Application.startLoading();
    TaxEventService.getTaxEvent(this.id).then(
      res => {
        this.taxEvent = res.data;
        this.populateForm();
        Application.stopLoading();
      },
      err => processError(err, this)
    );
  }

  populateForm(): void {
    if (!this.taxEvent) return;
    this.form = {
      year: this.taxEvent.year,
      period: this.taxEvent.period,
      dueDate: this.taxEvent.dueDate,
      eventDate: this.taxEvent.eventDate,
      paidOn: this.taxEvent.paidOn,
      amountCents: this.taxEvent.amountCents,
      status: this.taxEvent.status,
      paymentStatus: this.taxEvent.paymentStatus,
      risk: this.taxEvent.risk,
      obligation: this.taxEvent.obligation,
      nextAction: this.taxEvent.nextAction,
      taxTypeId: this.taxEvent.taxType ? this.taxEvent.taxType.id as number : null as any,
      customerId: this.taxEvent.customerId,
      customerType: this.taxEvent.customerType,
      assigneeId: this.taxEvent.assigneeId
    };
    
    if (this.taxEvent.amountCents) {
      this.amountLocal = (this.taxEvent.amountCents / 100).toFixed(2);
    } else {
      this.amountLocal = '';
    }

    if (this.taxEvent.assigneeId) {
      this.assignee = {
        id: this.taxEvent.assigneeId,
        firstName: this.taxEvent.assigneeName ? this.taxEvent.assigneeName.split(' ')[0] : '',
        lastName: this.taxEvent.assigneeName && this.taxEvent.assigneeName.split(' ')[1] ? this.taxEvent.assigneeName.split(' ').slice(1).join(' ') : ''
      } as any;
    } else {
      this.assignee = null;
    }
  }

  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    this.assignee = employee;
    if (employee) {
      this.form.assigneeId = employee.id;
    } else {
      this.form.assigneeId = null as any;
    }
  }
  
  get isValid(): boolean {
    if (this.$validator && this.$validator.errors.items.length > 0) return false;
    return !!(this.form.customerId && this.form.taxTypeId && this.amountLocal && this.form.eventDate && this.form.year && this.form.period && this.form.dueDate && this.form.status && this.form.paymentStatus && this.form.risk);
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get periodOptions() {
    return Object.values(Period).map(period => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(period)).value(period).build());
  }

  get statusOptions() {
    return Object.values(TaxEventStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get paymentStatusOptions() {
    return Object.values(PaymentStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get riskOptions() {
    return Object.values(Risk).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY');
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY HH:mm');
  }

  async save(): Promise<void> {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid) return;

    if (this.amountLocal) {
        this.form.amountCents = Math.round(parseFloat(this.amountLocal.toString()) * 100);
    }

    Application.startLoading();
    TaxEventService.updateTaxEvent(this.id, this.form as TaxEventPayload).then(
      res => {
        Application.stopLoading();
        // Optional: show toast message or redirect. Just reload to show updated DTO state.
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }

  addComment(): void {
    if (!this.commentPayload.comment.trim()) return;
    
    Application.startLoading();
    TaxEventService.addComment(this.id, this.commentPayload).then(
      res => {
        Application.stopLoading();
        this.commentPayload = new TaxEventCommentPayload();
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }
}
